import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CalendlyCallie } from '@calendly/ui/components/glyphs/CalendlyCallie'
import { IconHourglassEmpty } from '@calendly/ui/components/glyphs/IconHourglassEmpty'
import { IconLink } from '@calendly/ui/components/glyphs/IconLink'
import { IconMail } from '@calendly/ui/components/glyphs/IconMail'
import { Body, FooterUI, Popup } from '@calendly/ui/components/popup'
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconAction, colorIconInverseStandard, gradientIconAI } from '@calendly/ui/theme'

import {
  confirmationEmailCss,
  confirmationHeroCss,
  confirmationIconCss,
  confirmationNextCss,
  confirmationRowCss,
  confirmationRowsCss
} from './styles'

type SetupConfirmationProps = {
  email: string
  onClose: () => void
}

export const SetupConfirmation = ({ email, onClose }: SetupConfirmationProps) => (
  <Popup isBlocking withCloseButton onClose={onClose} size="medium">
    <Body>
      <div className={confirmationHeroCss}>
        <span className={confirmationIconCss}>
          <UiIcon icon={CalendlyCallie} color={colorIconInverseStandard} size="medium" title="" />
        </span>
        <TitleText level={2} size="medium">
          {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.title')}
        </TitleText>
        <BodyText inline>
          {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.subtitle')}
        </BodyText>
      </div>
      <div className={confirmationEmailCss}>
        <UiIcon icon={IconMail} color={gradientIconAI} size="medium" title="" />
        <BodyText inline>
          {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.email_sent', { email })}
        </BodyText>
      </div>
      <div className={confirmationNextCss}>
        <LabelText inline>
          {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.next_title')}
        </LabelText>
        <div className={confirmationRowsCss}>
          <div className={confirmationRowCss}>
            <UiIcon icon={IconMail} color={gradientIconAI} size="medium" title="" />
            <BodyText inline>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.next_email')}
            </BodyText>
          </div>
          <div className={confirmationRowCss}>
            <UiIcon icon={IconLink} color={colorIconAction} size="medium" title="" />
            <BodyText inline>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.next_link')}
            </BodyText>
          </div>
          <div className={confirmationRowCss}>
            <UiIcon icon={IconHourglassEmpty} color={gradientIconAI} size="medium" title="" />
            <BodyText inline>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.next_reminder')}
            </BodyText>
          </div>
        </div>
      </div>
    </Body>
    <FooterUI isOffset>
      <Button onClick={onClose}>
        {I18n.t('publisher.growth_experiments.callie_intro_entry_points.confirmation.dismiss')}
      </Button>
    </FooterUI>
  </Popup>
)
